module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - keunbon.989a9e28.pdf";